import React from 'react'
import ReactDOM from 'react-dom'
import Chart from 'chart.js'
import Modal from 'react-modal'
import MainNav from './MainNavComponent'
import { HashRouter } from 'react-router-dom'
import { initTheme } from './theme'

// Bootstrap 5, bundled from node_modules. The app previously loaded Bootstrap 4
// from a CDN here *and* Bootstrap 5 via the per-component CSS imports, so both
// versions were live at once: BS5 won for anything it defines, while BS4-only
// utilities (mr-*, form-group, badge-*, ...) still applied underneath. The CDN
// tags are gone; this import is the single source of Bootstrap for the app.
// The bundle build includes Popper, which the navbar dropdowns need.
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'

// Chart.js used to be loaded from cdnjs without Subresource Integrity, which let a
// CDN compromise run arbitrary script in this privileged origin. It is now bundled
// from node_modules. The chart components still reference the `Chart` global, so
// keep publishing it here until they are converted to import it directly.
window.Chart = Chart

// Pick the light or dark palette before anything renders. The CSS already
// follows the system setting; this applies a stored choice and hands the
// resolved colours to Chart.js.
initTheme()

// react-modal ships white inline defaults. Point them at the theme tokens
// (inline styles resolve var()) and lift the overlay above the sticky navbar.
Modal.defaultStyles = {
  overlay: {
    ...Modal.defaultStyles.overlay,
    zIndex: 1050,
    backgroundColor: 'rgba(5, 6, 36, 0.65)'
  },
  content: {
    ...Modal.defaultStyles.content,
    background: 'var(--msp-bg-secondary)',
    color: 'var(--msp-text-primary)',
    border: '1px solid var(--msp-border-color)',
    borderRadius: 'var(--msp-radius)'
  }
}

ReactDOM.render(
    <HashRouter>
        <MainNav />
    </HashRouter>, document.querySelector('#react-container'))
